export const units = {
  "2093-3": { unit: "mg/dL", range: [0, 200] },
  "2571-8": { unit: "mg/dL", range: [10, 150] },
  "2085-9": { unit: "mg/dL", range: [40, undefined] },
  "13457-7": { unit: "mg/dL", range: [70, 130] },
  "13458-5": { unit: "mg/dL" },
  "2885-2": { unit: "mg/dL", range: [5.5, 8] },
  "1751-7": { unit: "mg/dL", range: [3.5, 5.5] },
  "1975-2": { unit: "mg/dL", range: [0.3, 1] },
  "1968-7": { unit: "mg/dL", range: [0.1, 0.3] },
  "6768-6": { unit: "U/L", range: [30, 120] },
  "1920-8": { unit: "U/L", range: [0, 25] },
  "1742-6": { unit: "U/L", range: [0, 25] },
};
